import { render, staticRenderFns } from "./AdminFabricsEditScreen.vue?vue&type=template&id=09907f56&scoped=true&"
import script from "./AdminFabricsEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminFabricsEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09907f56",
  null
  
)

export default component.exports